'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00246 from "./presto.-Register-Page-View$$anon$6.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024 from "./presto.types$-Morbid-User-Details$.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterPageView$$anon$5() {
  this.btY = null;
  this.btQ = null;
  this.btR = false;
  this.btZ = null;
  this.bu0 = false;
  this.bu3 = null;
  this.btW = null;
  this.btX = false;
  this.btS = null;
  this.btT = false;
  this.btU = null;
  this.btV = false;
  this.bu1 = false;
  this.bu2 = false;
  this.btY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bu3 = "MorbidUserDetails";
}
export { $c_Lpresto_RegisterPageView$$anon$5 as $c_Lpresto_RegisterPageView$$anon$5 };
$p = $c_Lpresto_RegisterPageView$$anon$5.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterPageView$$anon$5;
/** @constructor */
function $h_Lpresto_RegisterPageView$$anon$5() {
}
export { $h_Lpresto_RegisterPageView$$anon$5 as $h_Lpresto_RegisterPageView$$anon$5 };
$h_Lpresto_RegisterPageView$$anon$5.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.btY;
});
$p.M = (function() {
  if ((!this.btR)) {
    this.btQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.btR = true;
  }
  return this.btQ;
});
$p.O = (function() {
  if ((!this.bu0)) {
    this.btZ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bu0 = true;
  }
  return this.btZ;
});
$p.E = (function() {
  return this.bu3;
});
$p.t = (function() {
  if ((!this.btX)) {
    this.btW = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.btX = true;
  }
  return this.btW;
});
$p.N = (function() {
  if ((!this.btT)) {
    this.btS = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().cJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.btT = true;
  }
  return this.btS;
});
$p.Q = (function() {
  if ((!this.btV)) {
    this.btU = new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00246.$c_Lpresto_RegisterPageView$$anon$6();
    this.btV = true;
  }
  return this.btU;
});
$p.v = (function() {
  if ((!this.bu2)) {
    this.bu1 = false;
    this.bu2 = true;
  }
  return this.bu1;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee48) => ((p) => \u03b4scrutinee48.Gp(p)))($j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024.$m_Lpresto_types$MorbidUserDetails$())));
});
var $d_Lpresto_RegisterPageView$$anon$5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterPageView$$anon$5, "presto.RegisterPageView$$anon$5", ({
  Qq: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_RegisterPageView$$anon$5 as $d_Lpresto_RegisterPageView$$anon$5 };
//# sourceMappingURL=presto.-Register-Page-View$$anon$5.js.map
